// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { productPrimaryImageStyles } from "@steiner/Overrides/Components/ProductPrimaryImage";
import { color } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

productPrimaryImageStyles.centeringWrapper = {
    css: css`
        min-height: 300px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
            height: auto;
            width: auto;
            max-width: 100%;
        }
    `,
};

productPrimaryImageStyles.container = {
    css: css`
        position: relative;
        img {
            object-fit: contain;
        }

        @media print {
            &,
            .EasyZoomImageHoverMainContainer {
                max-width: 300px;
                max-height: 300px;
                margin: 0 auto;
            }
        }
    `,
};

productPrimaryImageStyles.zoomContainerStyles = {
    css: css`
        width: 100%;
        cursor: zoom-in;
        // hides grey rectangle effect on selected zooming area
        img ~ div:not(#zoomTargeted) {
            display: none !important;
        }
        .EasyZoomImageHoverMainContainer {
            position: relative;
            width: 430px;
            height: 430px;
            display: flex;
            justify-items: start;
        }
        #zoomTargeted {
            top: 0;
            z-index: 1;
            width: ${({ width }: any) => width}px;
            background-color: ${color("common.white")};
            box-shadow: ${color("common.black", .25)} 0px 1px 6px 1px;
            display: none;
            img {
                max-width: 1380px !important; // have to set !important to override inline style from the library
                max-height: 840px;
                min-height: 100%;
                min-width: 100%;
            }
            @media print {
                display: none;
            }
            
        }
        &:hover #zoomTargeted {
            display: block;
            max-width: 690px !important; // have to set !important to override inline style from the library
            @media print {
                display: none;
            }
        }
    `,
};